const STUDENT_RESEARCH = {
  researchRoleInstructorOptions: [
    { key: "main", value: "main", title: "HD chính" },
    { key: "other", value: "other", title: "HD phụ" },
  ],
  researchRoleMemberOptions: [
    { key: "main", value: "main", title: "Chính" },
    { key: "other", value: "other", title: "Phụ" },
  ],
  // councilFieldKey CŨ đã bỏ (refactor 2026-05) — dùng `constants/councilRoles.js`
  // làm single source of truth thay vì hardcode 10 vị trí. Bất kỳ caller nào
  // cần list vai trò → import `COUNCIL_ROLES` từ `constants/councilRoles.js`.
  status: [
    { key: "giai-doan-0" },
    { key: "info_default" },
    { key: "info_accepted" },
    { key: "info_rejected" },
    { key: "member_default" },
    { key: "giai-doan-1" },
    { key: "member_accepted" },
    { key: "conducted" },
    { key: "rejected" },
    { key: "report_default" },
    { key: "report_submitted" },
    { key: "report_stop_default" },
    { key: "giai-doan-2" },
    { key: "report_stop_accepted" },
    { key: "report_adjust_accepted" },
    { key: "report_ensure" },
    { key: "default" },
    { key: "council_default" },
    { key: "submitted" },
    { key: "giai-doan-3" },
    { key: "council_accepted" },
    { key: "adjust_request" },
    { key: "giai-doan-4" },
    { key: "research_completed" },
    { key: "accepted" },
    { key: "giai-doan-5" },
  ],
};

const INSTITUTIONAL_PROJECT = {
  type: [
    { key: "basic", value: "basic", title: "Cơ bản" },
    { key: "applicational", value: "applicational", title: "Ứng dụng" },
  ],
  roleOptions: [
    { key: "main", value: "main", title: "Chủ nhiệm" },
    { key: "other", value: "other", title: "Thành viên" },
  ],
};

const ACHIEVEMENT = {
  awardType: [
    { key: "ho_chi_minh", value: "ho_chi_minh", title: "Giải thưởng Hồ Chí Minh" },
    { key: "nha_nuoc", value: "nha_nuoc", title: "Giải thưởng Nhà nước" },
    { key: "kovalevskaia", value: "kovalevskaia", title: "Giải thưởng Kovalevskaia" },
    { key: "creative_khcn", value: "creative_khcn", title: "Giải thưởng Sáng tạo KHCN Việt Nam" },
    { key: "young_lecturer", value: "young_lecturer", title: "Giải thưởng KHCN dành cho giảng viên trẻ" },
    { key: "student", value: "student", title: "Giải thưởng KHCN dành cho sinh viên" },
    { key: "other", value: "other", title: "Giải thưởng khác" },
  ],
  awardLevel: [
    { key: "first", value: "first", title: "Giải nhất" },
    { key: "second", value: "second", title: "Giải nhì" },
    { key: "third", value: "third", title: "Giải ba" },
    { key: "consolation", value: "consolation", title: "Giải khuyến khích" },
  ],
  roleOptions: [
    { key: "main", value: "main", title: "Tác giả chính" },
    { key: "member", value: "member", title: "Thành viên" },
  ],
};

const STUDENT_GUIDANCE = {
  guidanceType: [
    { key: "scientific_research", value: "scientific_research", title: "NCKH sinh viên" },
    { key: "thesis", value: "thesis", title: "Khóa luận tốt nghiệp" },
    { key: "graduation_project", value: "graduation_project", title: "Đồ án tốt nghiệp" },
    { key: "internship", value: "internship", title: "Thực tập" },
    { key: "other", value: "other", title: "Khác" },
  ],
  roleOptions: [
    { key: "main", value: "main", title: "Hướng dẫn chính" },
    { key: "co_instructor", value: "co_instructor", title: "Đồng hướng dẫn" },
  ],
};

const SCIENTIFIC_COUNCIL_NEW = {
  councilType: [
    { key: "research_group", value: "research_group", title: "Hội đồng đánh giá Hồ sơ thành lập Nhóm nghiên cứu" },
    {
      key: "internal_research_council",
      value: "internal_research_council",
      title: "Hội đồng đánh giá đề tài nghiên cứu cấp cơ sở",
    },
    { key: "textbook", value: "textbook", title: "Hội đồng nghiệm thu giáo trình" },
    { key: "uni_seminar", value: "uni_seminar", title: "Tổ chức hội thảo, Tọa đàm khoa học cấp Trường" },
    { key: "faculty_seminar", value: "faculty_seminar", title: "Tổ chức Hội thảo, Tọa đàm khoa học cấp Khoa/Viện" },
    {
      key: "student_research_reviewer",
      value: "student_research_reviewer",
      title: "Hội đồng khoa học đánh giá các đề tài tham gia Hội nghị sinh viên NCKH cấp trường",
    },
    {
      key: "student_research_acceptance",
      value: "student_research_acceptance",
      title: "Hội đồng nghiệm thu đề tài sinh viên NCKH cấp trường (có QĐ của Hiệu trưởng)",
    },
  ],
  roleOptions: [
    { key: "chairman", value: "chairman", title: "Chủ tịch HĐ" },
    { key: "secretary", value: "secretary", title: "Thư kí HĐ" },
    { key: "commissioner", value: "commissioner", title: "Ủy viên" },
    { key: "reviewer", value: "reviewer", title: "Ủy viên phản biện" },
  ],
};

export { STUDENT_RESEARCH, INSTITUTIONAL_PROJECT, ACHIEVEMENT, STUDENT_GUIDANCE, SCIENTIFIC_COUNCIL_NEW };

